import { PREVIEW_URL_PUBLISHED_ROUTE, PREVIEW_URL_UNPUBLISHED_ROUTE } from '@constants/routes';
import { Event, EventListItem } from '@domain/event';

export const createPreviewUrlWithoutQueryParams = ({
  event,
  locale,
  defaultChannel,
  isPublished,
}: {
  event: Event | EventListItem;
  locale: string;
  defaultChannel: string;
  isPublished: boolean;
}) => {
  if (isPublished)
    return PREVIEW_URL_PUBLISHED_ROUTE.replace(':lang', locale)
      .replace(':city-slug', event.club.city.slug)
      .replace(':event-slug', event.slug)
      .replace(':eventId', event.legacyId.toString())
      .replace(':channel-slug', defaultChannel);
  return PREVIEW_URL_UNPUBLISHED_ROUTE.replace(':lang', locale)
    .replace(':city-slug', event.club.city.slug)
    .replace(':event-slug', event.slug)
    .replace(':eventId', event.id)
    .replace(':channel-slug', defaultChannel);
};
